import { useState, useCallback } from 'react';
import { c212Api, FC210 } from '../../../services/c212Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master record (BR-C03 etc.) */
  const resolveAllNames = useCallback(async (data: Partial<FC210>) => {
    const entries: [string, string, string][] = [
      ['customer', 'customer', data.fc210_12 || ''],
      ['buyer', 'customer', data.fc210_13 || ''],
      ['salesPerson', 'employee', data.fc210_14 || ''],
      ['department', 'department', data.fc210_15 || ''],
      ['usage', 'usage', data.fc210_20 || ''],
      ['buyerCode', 'garmentBuyer', data.fc210_21 || ''],
      ['createdBy', 'employee', data.fc210_18 || ''],
      ['purchasePerson', 'employee', data.fc210_27 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        c212Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) [T-F04] */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await c212Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
